import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SERVER_API_URL } from './app.constants';
import { NavigationEnd, Router,  RoutesRecognized } from '@angular/router';
import { AnalyticsData } from './shared/analytics/analytics.model';
import { UserService } from './shared/user/user.service';
import { AnalyticsService } from './shared/analytics/analytics.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from './auth.config';
import { FilterService } from './filter/filter.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{

  title = 'spectrum-front';

  serverBaseUrl = SERVER_API_URL;
  filterData$ : Observable<any>;

  constructor(private translate: TranslateService,
    private router:Router,
    private userService : UserService,
    private oauthService: OAuthService,
    private filterService: FilterService,
    private analyticsService : AnalyticsService) {
    translate.setDefaultLang('en');
    //this.configureOAuth();
  }

  private configureOAuth() {
    this.oauthService.configure(authConfig);
    this.oauthService.loadDiscoveryDocumentAndLogin();
  }

  ngOnInit(): void {
    this.filterData$=this.filterService.getFilterData();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log("navigation end:"+event.urlAfterRedirects);
      }
      if (event instanceof RoutesRecognized) {
        console.log("routes recognised:"+event.urlAfterRedirects);
        let route =event.state.root.firstChild;
        let subUrl=route.url.join('/');
        let analytics=new AnalyticsData();
        analytics.uri=event.urlAfterRedirects;
        if(!subUrl.includes('accessDenied')){
          if(subUrl.includes('awards')){
            analytics.PageType='awards';
          }else if(subUrl.includes('licences')){
            analytics.PageType='licences';
          }else if(subUrl.includes('reports')){
            analytics.PageType='reports';
          }

          if(route.queryParams.regionCode){
            analytics.Region = analytics.Region.concat(route.queryParams.regionCode);
          }else{
            analytics.Region=this.userService.getRegions();
          }

          if(route.params.countryCode){
            analytics.country=route.params.countryCode;
          }
          if(route.params.bandGroup){
            analytics.bandGroup=route.params.bandGroup;
          }
          if(route.params.bandCode){
            analytics.band=route.params.bandCode;
          }
          if(route.params.awardKey){
            analytics.PageType="awardDetail";
            analytics.title=route.params.awardKey;
            analytics.country=route.params.awardKey.substring(0,2);
          }
          this.analyticsService.pushData(analytics);
        }

      }
    });
  }

  // switchLanguage(language: string) {
  //   this.translate.use(language);
  // }
}
